<template lang="html">
  	<div class="activityDetailContainer">
  		<div class="detailActivity">
	  		<div class="title">{{infoData.TITLE}}</div>
	  		<div class="date">{{infoData.PUB_TIME}}</div>
	  		<div class="date">{{"作者 小君  ●  "+infoData.CLICK_NUM+" 阅读  ●  会员活动，财富会员"}}</div>
	  		<div class="content">
	  			<div v-html='infoData.CONTENT'></div>
	  			<!-- <div v-html='html'></div> -->
	  		</div>
		</div>
		<div class="activityBoard">
			<div class="prevActivity" v-on:click="prevActivity">
				<span class="mui-icon mui-icon-arrowthinleft"></span>
				<span>上一篇</span>
			</div>
			<div class="board">
				<router-link to="/activityList"><img src="../../assets/img/activityBoard.png" /></router-link>
			</div>
			<div class="nextActivity" v-on:click="nextActivity">
				<span class="mui-icon mui-icon-arrowthinright"> </span>
				<span>下一篇</span>
			</div>
		</div>
    </div>
</template>
<script>
	import Server from '../../server/server.js'
	import {alertMsg} from '../../common/url.js';
	export default {
	  	name: 'activityDetailContainer',
	  	data(){
		  	return{
		  		typeCode:'',
		  		tagName:'',
		  		searchTxt:'',
		  		activityIndex:0,
		  	}
	  	},
	  	props:['infoData'],
	  	methods:{
	  		//点击上一篇
	  		prevActivity:function(){
	  			if(this.activityIndex == 0){
					alertMsg('已经是第一篇啦！');
				}else{
					this.activityIndex = parseInt(this.activityIndex-1);
					console.log(this.activityIndex);
					localStorage.setItem('activitySequence',this.activityIndex);//将标记减一
					this.getactivityInfo(this.activityIndex);
				}
	  		},
	  		//点击下一篇
	  		nextActivity:function(){
	  			this.activityIndex = parseInt(this.activityIndex)+1;
				localStorage.setItem('activitySequence',this.activityIndex);//将标记加一
				this.getactivityInfo(this.activityIndex);
	  		},
	  		//获取资讯详情
	  		getactivityInfo:function(activityIndex){
	  			Server.listInfo(activityIndex,activityIndex,this.typeCode,this.tagName,this.searchTxt).then((result)=>{
		  			if(result.code == '0'){
		  				let element =result.msg.infos;
		  				if(element.length>0){
							let infoId = element[0]['INFO_ID'];
							this.$router.push({name: 'activityDetail', params: {infoId: infoId}, query: {typeCode: this.typeCode}});
							Server.infoDetail(infoId).then((result)=>{
					  			if(result.code == '0'){
					  				this.infoData = result.msg;
					  				this.infoData.PUB_TIME =this.infoData.PUB_TIME.slice(0,10);
					  			}
					  		})
						}else{
							alertMsg('已经是最后一篇啦！');
							this.activityIndex = parseInt(this.activityIndex-1);
						}
		  			}
		  		})
	  		}
	  	},
	  	created(){
	  		this.typeCode = this.$route.query.typeCode;
	  	},
	  	mounted(){
	  		this.activityIndex = localStorage.getItem('activitySequence');//获取该文章所在栏目下的序号
	  	}
	}
</script>
<style lang="less" scoped>
	.activityDetailContainer{
		margin-top: 150px;
		width:100%;
		padding:0 40px;
		.detailActivity{
			margin-top: 20px;
			.title{
				font-size:48px;
				color:#ad8f5a;
				letter-spacing:0;
				line-height: 1.5em;
				text-align:left;
				margin-bottom:30px;
			}
			.date{
				font-size:24px;
				color:#b9b9b9;
				letter-spacing:0.86px;
				line-height:28px;
				text-align:left;
				margin-bottom:5px;
			}
			.content{
				margin-top:70px;
				font-size:28px;
				color:#000000;
				letter-spacing:0.1px;
				line-height:60px;
				text-align:left;
			}
			img{
				max-width:100%;
				margin-top: 10px;
			}
		}
		.activityBoard{
			margin-top:30px;
			width:100%;
			height:120px;
			background:#fafbfc;
			display:flex;
			align-items:center ;
			justify-content:space-between;
			padding:0 20px;
			font-size:28px;
			color:#333333;
			letter-spacing:1px;
			text-align:left;
			img{
				width:34px;
			}
		}
		.mui-icon{
			font-size:36px!important;
			font-weight:bold!important;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/activity/activityDetail.vue